import BackButton from '@/components/common/backButton/BackButton';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import PasswordReset from '@/pages/profile/PasswordReset';
import { useUserProfileData } from '@montugroup/circuit-shared/hooks/user/useGetUserProfile';
import theme from '@montugroup/circuit-shared/theme';
import { Alert, Box, Divider, Link, Stack, toast, Typography } from '@montugroup/design-system';
import { useEffect } from 'react';
import { DeactivateAccount } from './DeactivateAccount';
import { ProfileInfo } from './ProfileInfo';
import ShippingAddressForm from './ShippingAddressForm';
import ShippingAddressLoadingSkeleton from './ShippngAddressLoadingSkeleton';

const ProfileBanner = () => (
  <Alert
    severity="info"
    sx={{
      width: '100%',
      my: theme.spacing(6),
    }}
    data-testid="concession-discount-banner"
  >
    <Typography variant="inherit">
      To update your email or phone number, please{' '}
      <Link
        to="https://support.umeds.com.au/hc/en-au/articles/36042289598745-Contact-uMeds"
        rel="noopener noreferrer"
        target="_blank"
      >
        contact support
      </Link>
      .
    </Typography>
  </Alert>
);

export default function CustomerProfile() {
  const { data, isLoading, isSuccess, isError, getUserState } = useUserProfileData();
  const isDeactivateAccountShown = Boolean(useFeatureFlag('user_enable_account_deactivation'));

  useEffect(() => {
    if (!data && !isLoading && isError) {
      toast.error('Error retrieving profile data');
    }
  }, [data, isLoading, isError]);

  return (
    <Box>
      <Stack spacing={6} divider={<Divider />}>
        <Box>
          <Stack direction="row">
            <BackButton />
            <Typography
              variant="h5"
              component="h1"
              sx={(theme) => ({ color: theme.palette.primary.main })}
              lineHeight={(theme) => theme.spacing(10)}
            >
              Profile
            </Typography>
          </Stack>

          <ProfileBanner />

          <ProfileInfo data={data} isLoading={isLoading} isSuccess={isSuccess} />
        </Box>
        <Box>
          <Typography
            variant="h5"
            component="h1"
            sx={(theme) => ({ color: theme.palette.primary.main })}
            lineHeight={(theme) => theme.spacing(10)}
          >
            Shipping Address
          </Typography>
          {isLoading ? (
            <ShippingAddressLoadingSkeleton />
          ) : (
            Boolean(data) && <ShippingAddressForm userData={data} getUserState={getUserState} />
          )}
        </Box>
        <PasswordReset />
        {isDeactivateAccountShown && <DeactivateAccount />}
      </Stack>
    </Box>
  );
}
